import styled from "styled-components";

import UINotificationBase from "./Base";

const UINotificationFailure = styled(UINotificationBase)`
  background: ${p => p.theme.colors.monzaLightest};
  webkit-box-shadow: 0 4px 6px -6px #222;
  -moz-box-shadow: 0 4px 6px -6px #222;
  box-shadow: 0 4px 6px -6px #222;
`;

export default UINotificationFailure;
